'use client';

import Script from 'next/script';

export function AdyenDataCollectionScript() {
    return (
        <Script
            id="adyen-data-collection-sdk"
            src={process.env.NEXT_PUBLIC_ADYEN_DATA_COLLECTION_SDK_SCRIPT_URL}
            async
        />
    );
}
